<template>
  <div class="footer desktop">
    <div class="footer-logo">
<!--      <icon icon-class="logo" :w="180" :h="90"></icon>-->
      <img src="@/assets/images/ustc.png" width="100" height="100">
    </div>
    <div class="footer-name">Wei Chen Group @ USTC</div>
    <div class="footer-info">

      <div class="footer-info-title">CONTACT</div>
      <div class="footer-info-text"><a class="footer-link" href="mailto:weichen1@ustc.edu.cn">weichen1@ustc.edu.cn</a>
      </div><br>
      <div class="footer-info-title">COPYRIGHT</div>
      <div class="footer-info-text">Wei Chen Group 2021</div>
      <div class="footer-info-text">Designed by Zihan Lin</div>
    </div>
  </div>
  <div class="footer mobile">
    <div class="footer-logo">
      <!--      <icon icon-class="logo" :w="180" :h="90"></icon>-->
      <img src="@/assets/images/ustc.png" width="80" height="80">
    </div>
    <div class="footer-info">

      <div class="footer-info-title">CONTACT</div>
      <div class="footer-info-text"><a class="footer-link" href="mailto:weichen1@ustc.edu.cn">weichen1@ustc.edu.cn</a>
      </div><br>
      <div class="footer-info-title">COPYRIGHT</div>
      <div class="footer-info-text">Wei Chen Group 2021</div>
      <div class="footer-info-text">Designed by Zihan Lin</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WebFooter"
}
</script>

<style scoped>

.footer {
  display: flex;
  align-content: center;
  width: 100%;
  background-color: #005BAA;
  color: white;
  height: 130px;
  justify-content: space-between;
}

.footer-logo {
  display: inline-block;
  margin-left: 32px;
  margin-top:16px;
}

.footer-info {
  display: inline-block;
  text-align: right;
  margin-right: 5vw;
}

.footer-link {
  color: white;
}

.footer-link:hover {
  color: aqua;
}

.footer-info-title {
  margin: 4px 0;
  color: #0094ff;
}

.footer-info-text {
  font-weight: bold;
}

.a {
  content: "";
  position: absolute;
  left: 0;
  right: 54%;
  bottom: -5px;
  background: #339bf0;
  height: 4px;
}
.footer-name{
  font-size: 48px;
  line-height: 130px
}
@media screen and (max-width: 950px){
  .footer-name{
    font-size: 4vw;
  }
}
.desktop{
  display: flex;
}
.mobile{
  display: none;
}
@media screen and (max-width: 650px){
  .desktop{
    display: none;
  }
  .mobile{
    display: flex;
  }
}
</style>